const handleNumberInputWheel = () => {
  if (document.activeElement.type === 'number') {
    document.activeElement.blur()
  }
}

export default handleNumberInputWheel
